import { useTheme } from '@emotion/react';
import { Grid, Typography, Box, Checkbox, Divider, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useContext, useEffect, useState } from 'react';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import { FormContext } from '../../Context/formContext';
import { getSplitName } from '../../Utils/Helpers/stringHelper';
import PrintIcon from '@mui/icons-material/Print';
import { useRef } from 'react';
import React from 'react';
import ReactToPrint from 'react-to-print/lib';
import SummaryToPrint from './summaryToPrint';
import { useFormContext } from 'react-hook-form';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    height: 'calc(100% - 16px)',
    paddingTop: theme.spacing(7.125),
    overflow: 'auto',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      paddingTop: theme.spacing(3),
    },
  },
  stepLabel: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  sectionLabel: {
    fontWeight: 400,
  },
  sectionSubLabel: {
    color: '#7A869A',
    fontWeight: 400,
  },
  footerContainer: {
    position: 'absolute',
    bottom: '0px',
    padding: '16px',
    paddingRight: '223px',
    minHeight: 76,
    // height: "100px",
    left: '0px',
    right: '0px',
    overflow: 'hidden',
    background: '#FFFFFF',
    boxShadow:
      '10px 0px 20px rgba(0, 0, 0, 0.04), 2px 0px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    // backgroundColor: "blue",
  },
  container: {
    position: 'absolute',
    top: '270px',
    bottom: '0px',
    left: '0px',
    right: '0px',
  },
  paymentContainer: {
    padding: '16px 223px',
  },
  fieldNameValue: {
    wordBreak: 'break-word',
    fontWeight: 400,
  },
  fieldName: {
    color: '#7A869A',
  },
  fieldValue: {
    color: '#061938',
  },
  fieldContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      flexDirection: 'column',
      'align-items': 'flex-start',
      'justify-content': 'flex-start',
      'max-width': '100%',
      display: 'flex',
      width: '100%',
      'padding-top': '0 !important',
    },
  },
  fieldKeyContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: '40%',
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      'line-height': '150%',
      'text-transform': 'capitalize',
      color: '#7A869A',
    },
  },
  fieldValueContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: '60%',
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      'line-height': '150%',
      color: '#061938',
    },
  },
  divider: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      margin: '5px auto 16px 0',
    },
  },
  dividerContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      margin: '5px',
    },
  },
  dividerWrapper: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      margin: '0px',
      paddingTop: '0 !important',
    },
  },
}));

const KenSummary = React.forwardRef((props, ref) => {
  console.log(props, "Kensummary");
  const { formJson, data, applicationState, applicationDispatch } = props;
  const classes = useStyles();
  const theme = useTheme();
  const { formState, formDispatch } = useContext(FormContext);
  console.log(formJson, "formJson")
  console.log(applicationState, data, "dsd")
  const isMobileScreen = useMediaQuery(
    theme.breakpoints.down(TABLET_BREAKPOINT)
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  console.log(props);

  const getNestedFieldValue = (fieldName, index, nestedFieldName) => {
    if (data) {
      if (data[fieldName]) {
        if (data[fieldName][index]) {
          if (data[fieldName][index][nestedFieldName]) {
            return data[fieldName][index][nestedFieldName];
          }
        }
      }
    }
  };

  const getAt = (root, bracketPath) => {
    const path = (bracketPath.startsWith('data[') ? bracketPath : `data[${bracketPath}]`)
      .replace(/[\[\]']+/g, ".")
      .replace(/^\.+|\.+$/g, "")
      .split(".");
    return path.reduce((acc, key) => (acc == null ? acc : acc[key]), root);
  };

  // prefer sibling _select when present
  const getWithSelect = (root, bracketPath) => {
    const parts = (bracketPath.startsWith('data[') ? bracketPath : `data[${bracketPath}]`)
      .replace(/[\[\]']+/g, ".")
      .replace(/^\.+|\.+$/g, "")
      .split(".");
    const last = parts[parts.length - 1];
    const parent = parts.slice(0, -1).reduce((acc, k) => (acc == null ? acc : acc[k]), root);
    const sel = parent?.[`${last}_select`];
    if (sel !== undefined && sel !== null && sel !== "") return sel;
    return parts.reduce((acc, k) => (acc == null ? acc : acc[k]), root);
  };

  const checkFormOptions = (value) => {
    const all = Object.values(applicationState?.formOptions || {}).flat().filter(Boolean);
    const match = all.find((el) => el?.value === value);
    if (match?.label) return match.label;

    if (value === true || value === "true") return "Yes";
    if (value === false || value === "false") return "No";
    return value ?? "";
  };

  const norm = (s) => String(s ?? "").toLowerCase().replace(/\s+/g, " ").trim();

  // turn "applicant[trainingCentre]" into ["data","applicant","trainingCentre"]
  const toPathArray = (bracketPath) => {
    const normalized = (bracketPath.startsWith('data[') ? bracketPath : `data[${bracketPath}]`);
    return normalized
      .replace(/[\[\]']+/g, ".")
      .replace(/^\.+|\.+$/g, "")
      .split(".");
  };

  const getAtPath = (root, bracketPath, { preferSelect = true } = {}) => {
    const parts = toPathArray(bracketPath);
    // base value
    const base = parts.reduce((acc, key) => (acc == null ? acc : acc[key]), root);

    if (!preferSelect) return base;

    // try sibling _select at the last segment
    const last = parts[parts.length - 1];
    const parent = parts.slice(0, -1).reduce((acc, key) => (acc == null ? acc : acc[key]), root);
    const selectCandidate = parent?.[`${last}_select`];

    return selectCandidate ?? base;
  };

  const matchesRule = (field) => {
    const cond = field?.rule?.condition;
    if (!cond?.scope) return true;
    const actual = getAt({ data }, cond.scope);
    return norm(actual) === norm(cond.expectedValue);
  };


  const getFieldValue = (field) => {
    try {
      // Only return a value if this field's rule matches current data
      if (!matchesRule(field, { data })) return null;

      const raw = getAtPath({ data }, field.name, { preferSelect: true });
      return checkFormOptions(raw);
    } catch (e) {
      console.log("error in getFieldValue", e);
      return null;
    }
  }

  const getNestedData = (name, structure) => {
    console.log(name, structure);
    const flatStructureData = structure.map((a) => {
      return { name: a?.name, label: a?.label };
    });
    let dataByName;
    if (/\d/.test(name)) {
      dataByName = getFieldValue(name);
    } else {
      dataByName = data[name] || [];
    }
    const allData = dataByName?.map((el) => {
      let obj = {};
      flatStructureData?.forEach((item) => {
        obj[item.label] =
          item.name.includes('semester') || item.name.includes('year')
            ? el[item?.name]?.replace(/\D/g, '')
            : el[item?.name];
      });
      return obj;
    });
    return allData;
  };

  const initialDeclaration = JSON.parse(sessionStorage.getItem('declaration')) || false;
  const [declaration, setDeclaration] = useState(initialDeclaration);

  const handleClick = () => {
    const newDeclaration = !declaration;
    setDeclaration(newDeclaration);

    // Persist the new state to local storage
    sessionStorage.setItem('declaration', JSON.stringify(newDeclaration));

    applicationDispatch({ type: 'update', payload: { declaration: newDeclaration } });

    console.log(newDeclaration, "declaration");
  }


  // console.log(getFieldValue('applicant[combineFirstLast]'), "ssss")

  const printedByName = new Set();

  return (
    <div ref={ref}>
      <Box p={2}>
        <Typography
          align="left"
          marginBottom={isMobileScreen ? 0 : theme.spacing(4)}
          className={classes.stepLabel}
          fontSize="20px"
        >
          Summary
        </Typography>

        <Box pt={1}>
          {formJson?.map((step) => {
            return (
              <>
                <Grid container spacing={2}>
                  {step?.sections?.map((section, index) => {
                    return (
                      <>
                        {section.sectionVisible === true && (
                          <>
                            <Grid item xs={12}>
                              <Box>
                                {section?.sectionName && (
                                  <Typography
                                    align="left"
                                    marginBottom={
                                      isMobileScreen
                                        ? theme.spacing(1)
                                        : theme.spacing(4)
                                    }
                                    className={classes.sectionLabel}
                                    fontSize="20px"
                                  >
                                    {section?.sectionName}
                                  </Typography>
                                )}
                                {section?.subSectionName && (
                                  <Typography
                                    align="left"
                                    marginBottom={
                                      isMobileScreen
                                        ? theme.spacing(1)
                                        : theme.spacing(4)
                                    }
                                    className={classes.sectionSubLabel}
                                    variant="body2"
                                  >
                                    {section?.subSectionName}
                                  </Typography>
                                )}
                              </Box>
                            </Grid>

                            {/* <Box key={section.sectionId}> */}
                            {/* <Grid container spacing={6} rowSpacing={4}> */}
                            {section.fields.map((field, fieldIndex) => {
                              return field?.metaData?.addMultiple === true ? (
                                <Grid
                                  item
                                  container
                                  xs={12}
                                  md={12}
                                  spacing={3}
                                >
                                  <>
                                    {getNestedData(
                                      field.name,
                                      field.fieldsArray
                                    )?.map((nestedField, nestedFieldIndex) => {
                                      return (
                                        nestedField &&
                                        Object.keys(nestedField).map(
                                          (keyName, keyIndex) => {
                                            return (
                                              <>
                                                <Grid
                                                  item
                                                  container
                                                  xs={12}
                                                  md={6}
                                                  spacing={1}
                                                  className={
                                                    classes.fieldContainer
                                                  }
                                                >
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    textAlign="left"
                                                    className={
                                                      classes.fieldKeyContainer
                                                    }
                                                  >
                                                    <Typography
                                                      className={`${classes.fieldName} ${classes.fieldNameValue}`}
                                                      variant="h5"
                                                    >
                                                      {keyName}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    textAlign="left"
                                                    className={
                                                      classes.fieldValueContainer
                                                    }
                                                  >
                                                    <Typography
                                                      className={`${classes.fieldValue} ${classes.fieldNameValue}`}
                                                      variant="h5"
                                                    >
                                                      {nestedField[keyName]}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                                {Object.keys(nestedField)
                                                  ?.length -
                                                  1 ===
                                                  keyIndex &&
                                                  getNestedData(
                                                    field.name,
                                                    field.fieldsArray
                                                  )?.length -
                                                  1 !==
                                                  nestedFieldIndex && (
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      className={
                                                        classes.dividerContainer
                                                      }
                                                    >
                                                      <Divider
                                                        className={
                                                          classes.divider
                                                        }
                                                      />
                                                    </Grid>
                                                  )}
                                              </>
                                            );
                                          }
                                        )
                                      );
                                    })}
                                  </>
                                  {/* </Typography> */}
                                  {/* </Grid> */}
                                </Grid>
                              ) : field?.fieldId ? (
                                <>
                                  {(() => {
                                    const raw = getWithSelect({ data }, field.name);
                                    const value = checkFormOptions(raw);

                                    // 2) decide if we should render:
                                    //    - if rule matches AND value exists → render
                                    //    - else, if we haven't printed this name yet AND value exists → render once as fallback
                                    const shouldRender = (matchesRule(field) && !!value) || (!printedByName.has(field.name) && !!value);

                                    if (!shouldRender) return null;
                                    printedByName.add(field.name);

                                    return (
                                      <Grid
                                        item
                                        container
                                        xs={12}
                                        md={6}
                                        spacing={2}
                                        className={classes.fieldContainer}
                                      >
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={6}
                                          textAlign="left"
                                          className={classes.fieldKeyContainer}
                                        >
                                          <Typography
                                            className={`${classes.fieldName} ${classes.fieldNameValue}`}
                                            variant="h5"
                                          >
                                            {field?.label}
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={6}
                                          textAlign="left"
                                          className={classes.fieldValueContainer}
                                        >
                                          <Typography
                                            className={`${classes.fieldValue} ${classes.fieldNameValue}`}
                                            variant="h5"
                                          >
                                            {value}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    );
                                  })()}
                                  {field?.ui?.divider && (
                                    <Grid item xs={12} sm={12} md={12} lg={12} className={classes.dividerContainer}>
                                      <Divider className={classes.divider} />
                                    </Grid>
                                  )}
                                </>
                              ) : (
                                <>
                                  {field?.options.map((el) => {
                                    return (
                                      <>
                                        {getFieldValue(
                                          `${field.name}${el.fieldId}`
                                        ) && (
                                            <Grid
                                              item
                                              container
                                              xs={12}
                                              md={6}
                                              spacing={2}
                                              className={classes.fieldContainer}
                                            >
                                              <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                textAlign="left"
                                                className={
                                                  classes.fieldKeyContainer
                                                }
                                              >
                                                <Typography
                                                  className={`${classes.fieldName} ${classes.fieldNameValue}`}
                                                  variant="h5"
                                                >
                                                  {el?.label}
                                                </Typography>
                                              </Grid>
                                              <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={6}
                                                textAlign="left"
                                                className={
                                                  classes.fieldValueContainer
                                                }
                                              >
                                                <Typography
                                                  className={`${classes.fieldValue} ${classes.fieldNameValue}`}
                                                  variant="h5"
                                                >
                                                  {el &&
                                                    getFieldValue(
                                                      `${field.name}${el.fieldId}`
                                                    )}
                                                </Typography>
                                              </Grid>
                                            </Grid>
                                          )}
                                        {field?.ui?.divider && (
                                          <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            className={classes.dividerContainer}
                                          >
                                            <Divider
                                              className={classes.divider}
                                            />
                                          </Grid>
                                        )}
                                      </>
                                    );
                                  })}
                                </>
                              );
                            })}
                            {/* </Grid> */}
                            {/* {step?.sections?.length - 1 !== index && ( */}
                            <Grid
                              item
                              xs={12}
                              className={classes.dividerWrapper}
                            >
                              <Box
                                mt={3}
                                mb={6}
                                className={classes.dividerContainer}
                              >
                                <Divider className={classes.divider} />
                              </Box>
                            </Grid>
                            {/* )} */}
                            {/* </Box> */}
                          </>
                        )}
                      </>
                    );
                  })}
                </Grid>
              </>
            );
          })}
          <Typography align="left" className={classes.sectionLabel} fontSize="20px" mt={5}>
            Declaration
          </Typography>
          <Grid sx={{ display: "flex", alignItems: 'baseline' }}>
            <Grid item >
              <Checkbox
                value={declaration}
                checked={declaration}
                onClick={handleClick}
                disabled={applicationState?.declaration || declaration}
              />
            </Grid>
            <Grid item sx={{ textAlign: "justify" }}>
              <Typography sx={{ lineHeight: 2 }}>
                I hereby give consent to Samsung and its affiliates to use photographs and videos of me and my project, click my pictures or record our experience/statement which can be used for Samsung Innovation Campus CSR initiative by the Indian or International media.
                <br />
                I understand that my picture(s)/recording will be shared on various social media handles platforms such as Facebook, Instagram, X (formerly Twitter), YouTube and Newsroom etc.
                <br />
                I acknowledge that Samsung and its affiliates may edit, alter, or modify the photographs and videos at its discretion.
                <br />
                I state that my consent is voluntary and without coercion and that no compensation or benefit (in any form) is payable for the same.
                <br />
                I declare that neither I nor any of my legal heirs will make any claim as regards the usage of my picture/recording.
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
});

const KenSummaryStep = (props) => {
  const componentRef = useRef();
  const applicationState = props;
  console.log(applicationState, "applicatttttt")

  const pageStyle = `
  @page {
    size: A4;
  }

  @media all {
    .pagebreak {
      display: none;
    }
  }

  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }
`;
  return (
    <div>
      <Box display={'flex'} justifyContent={'end'} alignItems={'center'} gap={'10px'}>
        <ReactToPrint
          // pageStyle={pageStyle}
          // trigger={() => (
          //   <Grid container justifyContent="space-between">
          //     <Grid item></Grid>
          //     <Grid item alignItems="right" mb={-5}>
          //       <PrintIcon />
          //     </Grid>
          //   </Grid>
          // )}
          pageStyle="@size: 11.0in 8.5in; !important;"
          trigger={() => <PrintIcon style={{ cursor: 'pointer' }} />}
          content={() => componentRef.current}
          removeAfterPrint={false}
          copyStyles={true}
        />
      </Box>
      <KenSummary  {...props} />
      <div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
        <SummaryToPrint ref={componentRef} applicationState={applicationState?.applicationState} {...props} />
      </div>
    </div>
  );
};

export default KenSummaryStep;